import { createSlice } from "@reduxjs/toolkit";
import { cloneDeep } from "lodash";
import { COMPONENT_LIST_INIT_SORT } from "../constants";
import { malwareApi } from "../report/services/malware.api";
import { initializeState, reportCleared } from "./sdlcReportSlice";
import { restoreState } from "./utils";
export const initFilter = {
    hide_triaged: true,
    threat_name: null,
    threat_type: null,
};
export const initSort = {
    property: "threat_name",
    reverse: false,
};
export const initPagination = {
    currentPage: 1,
    itemsPerPage: 10,
};
export const initialState = {
    filter: initFilter,
    sort: initSort,
    pagination: initPagination,
    expandedRows: {},
    focusedRow: null,
    filteredByLink: false,
};
const malwareSlice = createSlice({
    name: "malware",
    initialState: initialState,
    reducers: {
        filterUpdated: (state, action) => {
            state.filter = cloneDeep(action.payload);
            state.filteredByLink = false;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        threatNameFiltered: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.hide_triaged = action.payload.hide_triaged;
            state.filter.threat_name = action.payload.threat_name;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        threatTypeFiltered: (state, action) => {
            state.filter = cloneDeep(initFilter);
            state.filter.threat_type = action.payload.threat_type;
            state.filter.hide_triaged = action.payload.hide_triaged;
            state.filteredByLink = true;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        resetFilter: (state) => {
            //preserve sort
            state.filter = cloneDeep(initFilter);
            state.filteredByLink = false;
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        sortUpdated: (state, action) => {
            state.sort = cloneDeep(action.payload);
            state.pagination.currentPage = 1;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        paginationUpdated: (state, action) => {
            state.pagination = action.payload;
            state.expandedRows = {};
            state.focusedRow = null;
        },
        focusedRowUpdated: (state, action) => {
            state.focusedRow = action.payload;
        },
        expandedRowsUpdated: (state, action) => {
            if (action.payload.expand) {
                state.expandedRows[action.payload.id] = {
                    pagination: initPagination,
                    sortBy: COMPONENT_LIST_INIT_SORT,
                };
            }
            else {
                delete state.expandedRows[action.payload.id];
            }
        },
        expandedRowPaginationUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].pagination =
                    action.payload.pagination;
            }
        },
        expandedRowSortUpdated: (state, action) => {
            if (state.expandedRows[action.payload.id]) {
                state.expandedRows[action.payload.id].sortBy = action.payload.sort;
                state.expandedRows[action.payload.id].pagination.currentPage = 1;
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(initializeState, (state, action) => {
            return restoreState(state, action.payload, "malware");
        });
        builder.addCase(reportCleared, () => {
            return cloneDeep(initialState);
        });
        builder.addMatcher(malwareApi.endpoints.getMalware.matchFulfilled, (state, action) => {
            if (!state.filteredByLink || action.payload.match_count !== 1)
                return;
            state.expandedRows[action.payload.malware[0].threat_details.uuid] = {
                pagination: initPagination,
                sortBy: COMPONENT_LIST_INIT_SORT,
            };
            state.focusedRow = action.payload.malware[0].threat_details.uuid;
        });
    },
});
export const { filterUpdated, threatNameFiltered, threatTypeFiltered, resetFilter, sortUpdated, paginationUpdated, expandedRowsUpdated, expandedRowPaginationUpdated, expandedRowSortUpdated, focusedRowUpdated, } = malwareSlice.actions;
export const selectFilter = (state) => state.report.malware.filter;
export const selectFilteredByLink = (state) => state.report.malware.filteredByLink;
export const selectSort = (state) => state.report.malware.sort;
export const selectPagination = (state) => state.report.malware.pagination;
export const selectExpandedRow = (state, id) => state.report.malware.expandedRows[id] !== undefined;
export const selectExpandedRowPagination = (state, id) => { var _a; var _b; return (_b = (_a = state.report.malware.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.pagination) !== null && _b !== void 0 ? _b : initPagination; };
export const selectExpandedRowSort = (state, id) => { var _a; var _b; return (_b = (_a = state.report.malware.expandedRows[id]) === null || _a === void 0 ? void 0 : _a.sortBy) !== null && _b !== void 0 ? _b : COMPONENT_LIST_INIT_SORT; };
export const selectFocusedRow = (state) => state.report.malware.focusedRow;
export const malwareReducer = malwareSlice.reducer;
export * as default from "./malwareSlice";
//# sourceMappingURL=malwareSlice.js.map